import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ChevronDownIcon } from 'lucide-react';
const faqs = [{
  question: '¿Sirve para mi país?',
  answer: 'Sí, las estrategias de negociación y re-ubicación son universales, y cubrimos las diferencias clave de lógica laboral en mercados hispanos.'
}, {
  question: '¿Es difícil de entender?',
  answer: 'No, está escrito en lenguaje claro, sin tecnicismos legales aburridos.'
}, {
  question: '¿Tengo acceso de por vida?',
  answer: 'Sí, una vez que lo descargas, es tuyo para siempre.'
}, {
  question: '¿Me ayuda si ya me despidieron hace una semana?',
  answer: 'Totalmente, nunca es tarde para aplicar la auditoría financiera y el sistema de re-ubicación rápida.'
}];
export function FAQ() {
  const [openIndex, setOpenIndex] = useState<number | null>(null);
  return <section className="bg-navy text-white py-16 px-6" data-id="element-14">
      <motion.div initial={{
      opacity: 0,
      y: 20
    }} whileInView={{
      opacity: 1,
      y: 0
    }} viewport={{
      once: true
    }} transition={{
      duration: 0.6
    }} className="max-w-3xl mx-auto" data-id="element-15">
        <h2 className="font-serif text-3xl md:text-4xl mb-12 text-center" data-id="element-16">
          Preguntas <span className="text-gold" data-id="element-17">Frecuentes</span>
        </h2>

        <div className="space-y-4" data-id="element-18">
          {faqs.map((faq, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 10
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.4,
          delay: index * 0.1
        }} className="bg-white/10 backdrop-blur-sm rounded-lg overflow-hidden" data-id="element-19">
              <button onClick={() => setOpenIndex(openIndex === index ? null : index)} className="w-full px-6 py-4 flex items-center justify-between text-left hover:bg-white/5 transition-colors" data-id="element-20">
                <span className="font-semibold text-lg" data-id="element-21">{faq.question}</span>
                <ChevronDownIcon className={`w-6 h-6 text-gold transition-transform ${openIndex === index ? 'rotate-180' : ''}`} data-id="element-22" />
              </button>
              <AnimatePresence data-id="element-23">
                {openIndex === index && <motion.div initial={{
              height: 0,
              opacity: 0
            }} animate={{
              height: 'auto',
              opacity: 1
            }} exit={{
              height: 0,
              opacity: 0
            }} transition={{
              duration: 0.3
            }} className="overflow-hidden" data-id="element-24">
                    <div className="px-6 pb-4 text-gray-300" data-id="element-25">{faq.answer}</div>
                  </motion.div>}
              </AnimatePresence>
            </motion.div>)}
        </div>
      </motion.div>
    </section>;
}